import { ReactElement } from 'react';
import { EmptyStateButton, Info, Tooltip, Typography } from '@weareopenr/component-library';
import { useItem } from 'src/hooks/useItem/useItem';
import AttributeRuleCard from './AttributeRuleCard';
import { ATTRIBUTE_RULES_TOOLTIP } from './constants';
import styles from './AttributeRulesTab.module.scss';

interface IAttributeRulesTabProps {
  itemId: string;
  onAddRule?: () => void;
}

const AttributeRulesTab = ({ itemId, onAddRule = () => undefined }: IAttributeRulesTabProps): ReactElement => {
  const { data: item } = useItem(itemId);
  const rules = item?.attribute_rules ?? [];

  const defaults = {
    consumerName: item?.consumerName ?? null,
    description: item?.description,
    plu: item?.plu,
    imageUrl: item?.image ?? null,
  };

  return (
    <div className={styles['container']}>
      <div className={styles['title']}>
        <Typography size="xlarge" weight="bold">
          Attribute Rules
        </Typography>
        <Tooltip text={ATTRIBUTE_RULES_TOOLTIP}>
          <Info />
        </Tooltip>
      </div>
      <EmptyStateButton label="+ Add attribute rule" onClick={onAddRule} />
      {rules.map((rule) => (
        <AttributeRuleCard key={rule.attribute_rule_id} rule={rule} defaults={defaults} />
      ))}
    </div>
  );
};

export default AttributeRulesTab;
